import { createAction, props } from '@ngrx/store'
import { EmployeeAPIModel, EmployeeData } from '../../models/api.model'

const actionEmployeePrefix = '[employee]'

export const fetch_employee_personal_info = createAction(`${actionEmployeePrefix} fetch_employee_personal_info`)

export const fetch_employee_personal_info_success = createAction(
  `${actionEmployeePrefix} fetch_employee_personal_info_success`,
  props<EmployeeAPIModel>()
)

export const update_employee_personal_info_action = createAction(
  `${actionEmployeePrefix} update_employee_personal_info_action`,
  props<EmployeeAPIModel>()
)

export const update_employee_personal_info_success_action = createAction(
  `${actionEmployeePrefix} update_employee_personal_info_success_action`,
  props<EmployeeAPIModel>()
)

export const fetch_employee_with_reference_details = createAction(
  `${actionEmployeePrefix} fetch_employee_with_reference_details`
)

export const fetch_employee_with_reference_details_success = createAction(
  `${actionEmployeePrefix} fetch_employee_with_reference_details_success`,
  props<EmployeeData>()
)
